"use strict";

var _classCallCheck = require("/Users/cex/Desktop/burnsignal/burnsignal-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/cex/Desktop/burnsignal/burnsignal-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bnc_notify_1 = __importDefault(require("bnc-notify"));

var config_1 = require("./config");

var instance = null;

var Notifier =
/*#__PURE__*/
function () {
  function Notifier(opts) {
    _classCallCheck(this, Notifier);

    opts = opts || {};
    var networkId = opts.networkId || 1;

    if (instance && instance.networkId === networkId) {
      this.notifier = instance;
    } else {
      instance = bnc_notify_1.default({
        dappId: config_1.blocknativeDappId,
        networkId: networkId
      });
      instance.networkId = networkId;
      this.notifier = instance;
    }

    this.notifier.config({
      darkMode: false,
      mobilePosition: 'bottom',
      desktopPosition: 'topRight',
      txApproveReminderTimeout: 20000,
      txStallPendingTimeout: 20000,
      txStallConfirmedTimeout: 90000
    });
    this.enabled = !opts.disableNotifications;
  }

  _createClass(Notifier, [{
    key: "notify",
    value: function notify(kind, message) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (!this.enabled) {
        return {
          dismiss: function dismiss() {// noop
          }
        };
      }

      if (typeof message !== 'string') {
        throw new Error('message must be a string');
      }

      var opts = {
        autoDismiss: options.timeout,
        message: message,
        type: kind,
        eventCode: 'notification'
      };

      if (/^0x[0-9a-f]+$/.test(message)) {
        return this.notifier.hash(message);
      } else {
        return this.notifier.notification(opts);
      }
    }
  }, {
    key: "enable",
    value: function enable(enabled) {
      this.enabled = enabled;
    }
  }]);

  return Notifier;
}();

exports.default = Notifier;